module.exports = __webpack_public_path__ + "img/user.bf3187c2.svg";